export default __webpack_public_path__ + "static/media/kyc-gov-doc.f44dc5db.svg";